// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.region-scroller-container {
    position: relative;
    margin-top: 2rem;
    width: 100%;
    height: fit-content;
}

div.region-scroller-container-outer {
    height: fit-content;
}

div.region-window {
    position: absolute;
    display: flex;
    width: var(--regionWindowWidth); /* calculated within associated tsx */
    left: var(--regionWindowLeft); /* calculated within associated tsx */
    height: 100%;
    top: 0px;
    touch-action: none;
    -webkit-touch-callout: none; /* prevents context menu */
}

div.region-window-inner {
    background-color: #60a9ef88;
    border-top: 3px solid #60a9ef;
    border-left: 3px solid #60a9ef;
    border-bottom: 3px solid #60a9ef;
    border-right: 0px;
    height: 100%;
    width: 100%;
    cursor: pointer;
}

    div.region-window-inner > span {
        background-color: #60a9ef;
        color: var(--color-background);
        border-radius: 2px;
        margin-left: 2px;
        font-size: 0.8em;
    }

div.region-window-sizer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background-color: #60a9ef88;
    border-top: 3px solid #60a9ef;
    border-right: 3px solid #60a9ef;
    border-bottom: 3px solid #60a9ef;
    border-left: 1px dotted #60a9ef;
    border-radius: 0px 6px 6px 0px;
    height: 100%;
    width: 12px;
}

    div.region-window-sizer.enabled {
        background-color: #60a9ef88;
        border-top-color: #60a9ef;
        border-right-color: #60a9ef;
        border-bottom-color: #60a9ef;
        border-left-color: #60a9ef;
        cursor: ew-resize;
    }

        div.region-window-sizer.enabled > span {
            background-color: #60a9ef;
        }

    div.region-window-sizer.disabled {
        background-color: var(--color-disabled-transparent-back);
        border-top-color: var(--color-disabled-back);
        border-right-color: var(--color-disabled-back);
        border-bottom-color: var(--color-disabled-back);
        border-left-color: var(--color-disabled-back);
        cursor: pointer;
    }

        div.region-window-sizer.disabled > span {
            background-color: var(--color-disabled-back);
        }

    div.region-window-sizer > span {
        display: block;
        height: 50%;
        width: 3px;
        margin-left: 2px;
    }

.content-allowance-container {
    display: flex;
    width: 100%;
}

    .content-allowance-container > *.fill {
        flex: 1 1 auto;
    }

    .content-allowance-container > *.fit {
        flex: 0 1 auto;
    }

.region-spill-area {
    display: flex;
    flex-wrap: wrap;
    align-self: center;
    height: fit-content;
    stroke: lightgrey;
    fill: lightgrey;
    padding: 0rem 1rem;
    cursor: pointer;
}

    .region-spill-area:hover {
        stroke: white;
        fill: white;
    }

.content-container {
    overflow-x: hidden;
    overflow-y: hidden;
}

.region-window-title-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    color: #60a9ef;
    transform: translate(-50%, -100%);
}

.region-title-indicator {
    height: 1rem;
    width: 1px;
    background-color: #60a9ef;
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/css/RegionScroller.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,+BAA+B,EAAE,qCAAqC;IACtE,6BAA6B,EAAE,qCAAqC;IACpE,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,2BAA2B,EAAE,0BAA0B;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;IAChC,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;IAEI;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,YAAY;IACZ,WAAW;AACf;;IAEI;QACI,2BAA2B;QAC3B,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;QAC5B,0BAA0B;QAC1B,iBAAiB;IACrB;;QAEI;YACI,yBAAyB;QAC7B;;IAEJ;QACI,wDAAwD;QACxD,4CAA4C;QAC5C,8CAA8C;QAC9C,+CAA+C;QAC/C,6CAA6C;QAC7C,eAAe;IACnB;;QAEI;YACI,4CAA4C;QAChD;;IAEJ;QACI,cAAc;QACd,WAAW;QACX,UAAU;QACV,gBAAgB;IACpB;;AAEJ;IACI,aAAa;IACb,WAAW;AACf;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,aAAa;QACb,WAAW;IACf;;AAEJ;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":["@import '../../css/App.css';\r\n\r\ndiv.region-scroller-container {\r\n    position: relative;\r\n    margin-top: 2rem;\r\n    width: 100%;\r\n    height: fit-content;\r\n}\r\n\r\ndiv.region-scroller-container-outer {\r\n    height: fit-content;\r\n}\r\n\r\ndiv.region-window {\r\n    position: absolute;\r\n    display: flex;\r\n    width: var(--regionWindowWidth); /* calculated within associated tsx */\r\n    left: var(--regionWindowLeft); /* calculated within associated tsx */\r\n    height: 100%;\r\n    top: 0px;\r\n    touch-action: none;\r\n    -webkit-touch-callout: none; /* prevents context menu */\r\n}\r\n\r\ndiv.region-window-inner {\r\n    background-color: #60a9ef88;\r\n    border-top: 3px solid #60a9ef;\r\n    border-left: 3px solid #60a9ef;\r\n    border-bottom: 3px solid #60a9ef;\r\n    border-right: 0px;\r\n    height: 100%;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n    div.region-window-inner > span {\r\n        background-color: #60a9ef;\r\n        color: var(--color-background);\r\n        border-radius: 2px;\r\n        margin-left: 2px;\r\n        font-size: 0.8em;\r\n    }\r\n\r\ndiv.region-window-sizer {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    background-color: #60a9ef88;\r\n    border-top: 3px solid #60a9ef;\r\n    border-right: 3px solid #60a9ef;\r\n    border-bottom: 3px solid #60a9ef;\r\n    border-left: 1px dotted #60a9ef;\r\n    border-radius: 0px 6px 6px 0px;\r\n    height: 100%;\r\n    width: 12px;\r\n}\r\n\r\n    div.region-window-sizer.enabled {\r\n        background-color: #60a9ef88;\r\n        border-top-color: #60a9ef;\r\n        border-right-color: #60a9ef;\r\n        border-bottom-color: #60a9ef;\r\n        border-left-color: #60a9ef;\r\n        cursor: ew-resize;\r\n    }\r\n\r\n        div.region-window-sizer.enabled > span {\r\n            background-color: #60a9ef;\r\n        }\r\n\r\n    div.region-window-sizer.disabled {\r\n        background-color: var(--color-disabled-transparent-back);\r\n        border-top-color: var(--color-disabled-back);\r\n        border-right-color: var(--color-disabled-back);\r\n        border-bottom-color: var(--color-disabled-back);\r\n        border-left-color: var(--color-disabled-back);\r\n        cursor: pointer;\r\n    }\r\n\r\n        div.region-window-sizer.disabled > span {\r\n            background-color: var(--color-disabled-back);\r\n        }\r\n\r\n    div.region-window-sizer > span {\r\n        display: block;\r\n        height: 50%;\r\n        width: 3px;\r\n        margin-left: 2px;\r\n    }\r\n\r\n.content-allowance-container {\r\n    display: flex;\r\n    width: 100%;\r\n}\r\n\r\n    .content-allowance-container > *.fill {\r\n        flex: 1 1 auto;\r\n    }\r\n\r\n    .content-allowance-container > *.fit {\r\n        flex: 0 1 auto;\r\n    }\r\n\r\n.region-spill-area {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-self: center;\r\n    height: fit-content;\r\n    stroke: lightgrey;\r\n    fill: lightgrey;\r\n    padding: 0rem 1rem;\r\n    cursor: pointer;\r\n}\r\n\r\n    .region-spill-area:hover {\r\n        stroke: white;\r\n        fill: white;\r\n    }\r\n\r\n.content-container {\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n}\r\n\r\n.region-window-title-container {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: #60a9ef;\r\n    transform: translate(-50%, -100%);\r\n}\r\n\r\n.region-title-indicator {\r\n    height: 1rem;\r\n    width: 1px;\r\n    background-color: #60a9ef;\r\n    align-self: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
